<template>
    <v-container
        class="content-block-v2"
        :class="[
            blockClass,
            {
                'pa-0': fullBleed || !modelValue.values.padBlock,
                'h-100': fullBleed
            }
        ]"
        :fluid="fullBleed || modelValue.values.widthType === 'fluid'"
    >
        <component
            :is="currentBlock"
            :model-value="modelValue.values"
            :is-mobile="isMobile"
            :breakpoint="breakpoint"
            :breakpoint-name="breakpointName"
        ></component>
    </v-container>
</template>

<script lang="ts" setup>
    import type {
        ContentBlockRendered
    } from '~/types';
    import { useDisplay } from 'vuetify';
    import { kebabCase as lo_kebabCase } from 'es-toolkit';


    const props = defineProps<{
        modelValue: ContentBlockRendered;
        fullBleed?: boolean;
    }>();

    const {
        mobile: isMobile,
        name: breakpointName
    } = useDisplay();

    const blocks = {
        BlockXSplitFeature: resolveComponent('LazyContentBlocksV2BlockXSplitFeature'),
        BlockYSplitFeature: resolveComponent('LazyContentBlocksV2BlockYSplitFeature'),
        BlockZSplitFeature: resolveComponent('LazyContentBlocksV2BlockZSplitFeature'),
        BlockXSplitHeroCarouselItem: resolveComponent('LazyContentBlocksV2BlockXSplitHeroCarouselItem'),
        BlockYSplitHeroCarouselItem: resolveComponent('LazyContentBlocksV2BlockYSplitHeroCarouselItem'),
        BlockZSplitHeroCarouselItem: resolveComponent('LazyContentBlocksV2BlockZSplitHeroCarouselItem'),
        BlockShowcaseTile: resolveComponent('LazyContentBlocksV2BlockShowcaseTile')
    };

    const blockClass = computed<string>(() => {
        const templateRef = props.modelValue.template?.ref ?? 'unknown';
        return `content-block-${lo_kebabCase(templateRef)}`;
    });

    const currentBlock = computed<Nullable<typeof blocks[keyof typeof blocks]>>(() => {
        const templateRef = props.modelValue.template?.ref;

        if (!templateRef) return null;

        const block = blocks[`Block${templateRef}` as keyof typeof blocks];

        if (!block) {
            console.warn(`BlockRenderer: No component found for block name "Block${templateRef}".`);
            return null;
        }

        return block;
    });

    const breakpoint = computed<string>(() => (isMobile.value ? 'mobile' : 'desktop'));
</script>

<style lang="scss"></style>
